'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.performSubscribe = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _timeout = require('q/js/lib/timeout');

var _timeout2 = _interopRequireDefault(_timeout);

var _parseAblyMessage = require('../operators/parseAblyMessage');

var _errorInfoToError = require('../operators/errorInfoToError');

var _realtimeApiVersions = require('../constants/realtimeApiVersions');

var _defaults = require('../constants/defaults');

var _channelStates = require('../constants/channelStates');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var performSubscribe = exports.performSubscribe = function performSubscribe(channels, channelId, onMessage) {
  return (0, _timeout2.default)(new _q2.default.Promise(function (resolve, reject) {
    var channel = channels.get(channelId);

    var handleMessage = function handleMessage(unparsedMessage) {
      var parsedMessage = void 0;

      try {
        parsedMessage = (0, _parseAblyMessage.parseAblyMessage)(unparsedMessage);
      } catch (error) {
        onMessage(null, error);
        return;
      }

      onMessage(parsedMessage);
    };

    if (channel.state === _channelStates.ATTACHED) {
      resolve();
    } else {
      channel.attach(function (errorInfo) {
        if (errorInfo) {
          reject((0, _errorInfoToError.errorInfoToError)('PubSub attach failed', channelId, errorInfo));
        } else {
          resolve();
        }
      });
    }

    channel.subscribe(_realtimeApiVersions.REALTIME_API_V1, handleMessage);
  }), _defaults.PROMISE_TIMEOUT_MS, 'PubSub subscribe timeout');
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/performSubscribe.js
// module id = 781
// module chunks = 2 3